import { Z_INDEX_COPILOT_SIDEBAR } from '../../../constants/z_index';
const COPILOT_SIDEBAR_WIDTH = '400';
export const getStyle = () => ({
  border: '1px solid transparent',
  background: 'linear-gradient(#ffffff,#ffffff,#ffffff) padding-box,linear-gradient(#ff4800,#fc0849,#d20688) border-box',
  boxShadow: 'none',
  borderRadius: '16px',
  height: `calc(100vh - var(--global-nav-height, 44px))`,
  // Matches HEADER_HEIGHT calculation in chatspot-ui
  width: `${COPILOT_SIDEBAR_WIDTH}px`,
  position: 'fixed',
  top: `calc(var(--global-nav-height, 44px) + 8px)`,
  // Add 8px top margin
  right: '8px',
  // Add 8px right margin
  zIndex: Z_INDEX_COPILOT_SIDEBAR
});